/**
 * Insights sub-view navigation for the Insights tab.
 * 4 buttons: KPI Drivers, Portfolio Composition, Template Calibration, Custom Explorer.
 * Active state from insightsSubView in DashboardContext.
 */

import { BarChart3, PieChart, Target, Compass } from 'lucide-react';

import { cn } from '@/lib/utils';
import { useDashboardContext } from '@/pages/dashboard/DashboardContext';
import type { InsightsSubView } from '@/types/dashboard';

// ============================================================================
// SUB-VIEW OPTIONS
// ============================================================================

const SUB_VIEWS: { id: InsightsSubView; label: string; icon: typeof BarChart3 }[] = [
  { id: 'drivers', label: 'KPI Drivers', icon: BarChart3 },
  { id: 'composition', label: 'Portfolio Composition', icon: PieChart },
  { id: 'calibration', label: 'Template Calibration', icon: Target },
  { id: 'explorer', label: 'Custom Explorer', icon: Compass },
];

// ============================================================================
// COMPONENT
// ============================================================================

export function InsightsNav() {
  const { filters, setFilter } = useDashboardContext();
  const activeView = filters.insightsSubView ?? 'drivers';

  return (
    <div className="flex items-center gap-1.5 mb-4">
      {SUB_VIEWS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => setFilter('insightsSubView', id)}
          className={cn(
            'flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors',
            activeView === id
              ? 'bg-brand text-white'
              : 'bg-surface border border-border-subtle text-secondary hover:bg-surface-subtle'
          )}
        >
          <Icon size={14} />
          {label}
        </button>
      ))}
    </div>
  );
}
